import * as d3 from 'd3';

export const createViz = ({ element, selector, config }) => {
  const el = d3.select(element).select(selector);
  el.selectAll('*').remove();
  el.attr('width', config.width);
  el.attr('height', config.height);
  return el;
};
